// Highlight targets the page knows how to draw, by `target.kind`. A future image family adds an entry
// (e.g. IMAGE_REGIONS) and its renderer, without touching the page. Unknown kinds are ignored.
export const highlightTargets = Object.freeze({
    TEXT_INDEXES: (target) => (Array.isArray(target.indexes) ? target.indexes : []),
});

export const ROLE_CLASSES = Object.freeze({ MARKER: 'marker', ANSWER: 'answer', SKIPPED: 'skipped' });

// highlights -> Map(index -> Set(role)). Indexes are 0-based in the displayed string, spaces included.
// Out-of-range or non-integer indexes, unknown roles and unknown target kinds are ignored.
export const indexRoles = (highlights, length) => {
    const roles = new Map();
    if (!Array.isArray(highlights)) return roles;
    highlights.forEach((highlight) => {
        if (!highlight || !ROLE_CLASSES[highlight.role] || !highlight.target) return;
        const read = highlightTargets[highlight.target.kind];
        if (!read) return;
        read(highlight.target).forEach((index) => {
            if (!Number.isInteger(index) || index < 0 || (Number.isInteger(length) && index >= length)) return;
            if (!roles.has(index)) roles.set(index, new Set());
            roles.get(index).add(ROLE_CLASSES[highlight.role]);
        });
    });
    return roles;
};

export const hasRole = (highlights, role) =>
    Array.isArray(highlights) && highlights.some((highlight) => highlight && highlight.role === role);
